export const generateSequence = (digitSize, count) => {
  const getRandom = () => {
    switch (digitSize) {
      case "Single":
        return Math.floor(Math.random() * 9) + 1;
      case "Double":
        return Math.floor(Math.random() * 89) + 11;
      case "Triple":
        return Math.floor(Math.random() * 899) + 101;
      case "Quad":
        return Math.floor(Math.random() * 8999) + 1001;
      default:
        return 1;
    }
  };

  let sequence = [];
  let sum = 0;

  for (let i = 0; i < count; i++) {
    let num;
    let isAdd;

    do {
      num = getRandom();
      isAdd = Math.random() > 0.5;

      if (!isAdd && sum - num < 0) {
        isAdd = true;
      }

    } while (!isAdd && sum - num < 0);

    sequence.push({
      value: num,
      type: isAdd ? "add" : "sub",
    });

    sum = isAdd ? sum + num : sum - num;
  }

  return {
    sequence,
    answer: sum,
  };
};

export const generateMultiplicationSequence = (digitSize, count) => {
  const getRandom = () => {
    switch (digitSize) {
      case "Single":
        return Math.floor(Math.random() * 9) + 1;
      case "Double":
        return Math.floor(Math.random() * 89) + 11;
      case "Triple":
        return Math.floor(Math.random() * 899) + 101;
      case "Quad":
        return Math.floor(Math.random() * 8999) + 1001;
      default:
        return 1;
    }
  };

  let sequence = [];
  let product = 1;

  for (let i = 0; i < count; i++) {
    const num = getRandom();
    sequence.push({
      value: num,
      type: "mul", // multiplication
    });
    product *= num;
  }

  return {
    sequence,
    answer: product,
  };
};

export const generateDivisionSequence = (dividendSize, divisorSize) => {
  const getNum = (size) => {
    const min = Math.pow(10, size - 1);
    const max = Math.pow(10, size) - 1;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  let dividend, divisor;
  
  // Find a dividend and divisor of correct sizes that divide cleanly
  let attempts = 0;
  while (attempts < 100) {
    divisor = getNum(divisorSize);
    dividend = getNum(dividendSize);
    
    // Adjust dividend to be divisible by divisor
    dividend = Math.floor(dividend / divisor) * divisor;
    
    // Check if dividend still has the correct number of digits
    if (dividend.toString().length === dividendSize && dividend > 0) {
      break;
    }
    attempts++;
  }

  return {
    sequence: [
      { value: dividend, type: "dividend" },
      { value: divisor, type: "divisor" }
    ],
    answer: dividend / divisor,
  };
};